import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// Ops-wide cash-handover history (all agents), for Ops Review -> Cash Handover.
export default class CashHandoverService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getForReview(fromDate, toDate, storeID, onlyFlagged, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_CASH_HANDOVER_REVIEW });
    let rows = [];
    let payload = { fromDate, toDate, storeID, onlyFlagged };
    await api.endpoints[this.endpoint.GET_CASH_HANDOVER_REVIEW]
      .getAllPost(payload)
      .then((response) => { rows = response.data; })
      .catch((err) => { rows = this.common.handleError(err); });

    if (rows && rows.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        rows = await this.getForReview(fromDate, toDate, storeID, onlyFlagged, true);
      } catch (e) {
        rows = { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return rows;
  }
}
